export default "__VITE_ASSET__DOIRXnn$__"